import error from "./error";
import role from "./role";


export default {
    error: error,
    role: role,
}
